/**
 * GraphQL Query
 * サイトロール画面
 */

/**
 * サイトロール一覧
 */
export const GRAPH_QL_QUERY_SITE_ROLE_LIST =
`
query {
  siteRoles ( ? ) {
    uuid
    name
  }
}
`

/**
 * サイトロール詳細
 */
export const GRAPH_QL_QUERY_SITE_ROLE_DETAIL =
`
query {
  siteRoles {
    uuid
    name
    sites {
      code
    }
    updatedAt
  }
}
`



// WEBPACK FOOTER //
// ./src/queries/siteRole.js